import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
const Loader = (props) => {
    return (React.createElement("div", { className: 'h-full w-full' },
        React.createElement("div", { className: "card absolute top-50 left-50", style: { transform: 'translate(-50%,-50%)' } },
            React.createElement(ProgressSpinner, null))));
};
export default Loader;
